import { Colors } from "../constants/colors";
import { FONT_FAMILIES, htmlStyles } from "./styles";

export const muiTabs = {
  styleOverrides: {
    root: {
      minHeight: 33,
    },
    indicator: {
      borderBottom: `3px solid ${Colors.GREY500}`,
    },
  },
};

export const muiTab = {
  styleOverrides: {
    root: {
      textTransform: "none",
      minHeight: 33,
      paddingTop: 3,
      paddingBottom: 10,
      ...htmlStyles.body1,
      "&.Mui-selected": {
        color: Colors.GREY500,
        ...FONT_FAMILIES.REGULAR,
      },
    },
  },
};
